<template>
  <svg
    :height="height"
    :width="width"
    id="Layer_1"
    style="enable-background:new 0 0 100 100;"
    version="1.1"
    viewBox="0 0 100 100"
    x="0px" y="0px"
    xml:space="preserve"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    >
    <g>
      <polygon class="st0" fill="#ECEFF0" points="19.3,9.9 15.9,26.7 79.3,29 84.3,39.9 84.3,80.7 90.6,77.1 97.7,26.1 93.5,17.5   "/>
      <circle class="st0" fill="#ECEFF0" cx="50.2" cy="48.2" r="6.3"/>
      <path class="st1" :fill="iconColor" d="M50.6,58.1c5.6,0,10.2-4.6,10.2-10.2s-4.6-10.2-10.2-10.2s-10.2,4.6-10.2,10.2S45,58.1,50.6,58.1L50.6,58.1z
         M50.6,42.5c3,0,5.3,2.4,5.3,5.3c0,3-2.4,5.3-5.3,5.3c-3,0-5.3-2.4-5.3-5.3C45.3,44.9,47.7,42.5,50.6,42.5L50.6,42.5z"/>
      <polygon class="st0" fill="#ECEFF0" points="2.7,75.2 26.3,58.1 51.9,74.2 82.5,58.1 82.5,88.6 72.2,91.8 6,91.8  "/>
      <path class="st1" :fill="iconColor" d="M91.3,14.3L25,6.8c-2.6-0.4-5.2,0.4-7.2,2.1c-2,1.5-3.3,3.8-3.5,6.3l-1.2,10H9.4C4,25.1,0,29.9,0,35.2v49.7
        c-0.1,5.1,3.9,9.3,9,9.5c0.1,0,0.2,0,0.4,0H76c5.3,0,10.2-4.1,10.2-9.5V83c1.7-0.3,3.2-1,4.6-1.9c2-1.7,3.2-4,3.5-6.6l5.6-49.3
        C100.5,19.8,96.7,15,91.3,14.3z M9.4,30H76c2.9,0.1,5.2,2.4,5.3,5.2v20.4L54.9,71.1c-2.3,1.3-5.2,1.1-7.2-0.6L34.4,58.7
        c-3.8-3.3-9.4-3.5-13.5-0.5l-16,11.7V35.2C4.9,32.6,6.7,30,9.4,30z M76,89.5H9.4c-2.4,0.1-4.4-1.8-4.5-4.2c0-0.1,0-0.2,0-0.4v-9
        l18.8-13.8c2.3-1.7,5.4-1.6,7.5,0.4l13.2,11.7c2,1.7,4.5,2.6,7.2,2.7c2.1,0,4.1-0.5,5.8-1.6l23.9-13.8v23.6
        C81.4,87.6,78.7,89.5,76,89.5z M95.1,24.5l-5.7,49.3c0,1.3-0.6,2.5-1.6,3.3c-0.5,0.5-1.6,0.7-1.6,1V35.2c-0.2-5.5-4.7-10-10.2-10.1
        H18l1.1-9.5c0.2-1.2,0.9-2.3,1.8-3.2c1.1-0.7,2.4-1.1,3.6-1l66.2,7.7C93.4,19.5,95.3,21.8,95.1,24.5C95.1,24.5,95.1,24.5,95.1,24.5
        z"/>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
